import { UtilitarioService } from "@app/services/utilitario.service";

export class RateioFaturamentoModel{
    public UnidadeId: number;
    public UnidadeDescricao: string;
    public UnidadeValor: number;
    public UnidadePercentual: number;
    public UnidadeEditada: boolean;
    public EdicaoConcluida: boolean;
    public Editando: boolean;
}

export class RateioFaturamentoInput{
    public FaturamentoBase: string;
    public DataFinal: string;

    constructor(){
        this.DataFinal = UtilitarioService.retornaDataUltimoDiaDoMesAnterior(1);
    }
}